/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import flowGraphReceiveCustomEventBlock.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./flowGraphReceiveCustomEventBlock.pure";
import { RegisterFlowGraphReceiveCustomEventBlock } from "./flowGraphReceiveCustomEventBlock.pure";
RegisterFlowGraphReceiveCustomEventBlock();
//# sourceMappingURL=flowGraphReceiveCustomEventBlock.js.map